import Http from "./HttpService";

import { DEFAULT_LIMIT, DEFAULT_OFFSET } from "../constants/pagination";

class ReferralSourcesService extends Http {
  BASE_URL = "/admins/referral-sources";

  getList(pagination = {}) {
    const { limit = DEFAULT_LIMIT, offset = DEFAULT_OFFSET } = pagination;

    return this.get(`${this.BASE_URL}`, {
      params: {
        limit,
        offset,
      },
    });
  }

  create(model) {
    return this.post(`${this.BASE_URL}`, model);
  }

  async getOne(id) {
    const { data } = await this.get(`${this.BASE_URL}/${id}`);
    if (!data.referralSourceThumbnailImage) {
      return { data };
    }
    // const initialFile = data.image;
    // initialFile.preview = data.image.resizedImages
    //   ? data.image.resizedImages[Object.keys(data.image.resizedImages)[0]]
    //   : data.image.link;
    // initialFile.size = null;

    let referralSourceThumbnailImageInitialFile = null;
    
    if (data.referralSourceThumbnailImage) {
      referralSourceThumbnailImageInitialFile = data.referralSourceThumbnailImage;
    referralSourceThumbnailImageInitialFile.preview = data.referralSourceThumbnailImage.resizedImages
      ? data.referralSourceThumbnailImage.resizedImages[Object.keys(data.referralSourceThumbnailImage.resizedImages)[0]]
      : data.referralSourceThumbnailImage.link;
      referralSourceThumbnailImageInitialFile.size = null;
    }

    return { data: { ...data, referralSourceThumbnailImageInitialFile } };
  }

  update(id, model) {
    return this.put(`${this.BASE_URL}/${id}`, model);
  }

  addReferralSourceThumbnailImage(id, model) {
    return this.post(`${this.BASE_URL}/${id}/referral-source-thumbnail-image`, model);
  }

  // changeStatus(id) {
  //   return this.patch(`${this.BASE_URL}/${id}/status`);
  // }

  // remove(id) {
  //   return this.delete(`${this.BASE_URL}/${id}`);
  // }

  // addImageToBundle(id, model) {
  //   return this.post(`${this.BASE_URL}/${id}/image`, model);
  // }


  // addVideo(id, model) {
  //   return this.post(`${this.BASE_URL}/${id}/video`, model);
  // }

  // changeVideoThumbnail(bundleId, videoThumbnailId) {
  //   return this.put(
  //     `${this.BASE_URL}/${bundleId}/video/thumbnail`,
  //     {
  //       videoThumbnailId,
  //     },
  //     {
  //       disableToast: true,
  //     }
  //   );
  // }

  // getAllBundlesList(pagination = {}) {
  //   const { limit = DEFAULT_LIMIT, offset = DEFAULT_OFFSET } = pagination;

  //   return this.get(`/bundles`, {
  //     params: {
  //       limit,
  //       offset,
  //     },
  //   });
  // }
}

export default new ReferralSourcesService();
